import { render } from "./NavbarSlider.vue?vue&type=template&id=2a37c479"
import script from "./NavbarSlider.vue?vue&type=script&lang=js"
export * from "./NavbarSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__